import { combineReducers } from 'redux';
import stakeholder from './stakeholder';
import stakeholder_Type from './type-stakeholder';

const RIndex = combineReducers({
    stakeholder,
    stakeholder_Type
})

export default RIndex;